export const transfers = state => {
    return state.transfersSelected;
};
export const margin = state => {
    return state.margin;
};
export const operations = state => {
    return state.operationsSelected;
};
export const groupedSelected = state => {
    return state.groupedSelected;
};
export const uuidGroupedSelected = state => {
    return state.uuidGroupedSelected;
};
export const suggestions = state => {
    return state.suggestions;
};
export const disableGroups = state => {
    return state.disableGroups;
};
export const comment = state => {
    return state.comment;
};
export const searchBy = state => {
    return state.searchBy;
};
export const disableAll = state => {
    return state.disableAll;
};
